module.exports = __webpack_public_path__ + "img/hipercard.f4b35272.png";